import ZFormItem from '../form/form-item.vue'

ZFormItem.install = function(app) {
  app.component(ZFormItem.name, ZFormItem)
}

export default ZFormItem